module.exports = __webpack_public_path__ + "static/media/fill-available.ca031e49.gif";